import React from 'react';
import './style.scss';
import favorite from '../../../assets/img/favorite.png';
import {IS_PLATFORM_IOS} from "../../../services/utils/platforms";
import classNames from 'classnames';

const EmptyFavorite = () => (
    <div className={classNames({
        "empty-favorite": true,
        "empty-favorite--ios": IS_PLATFORM_IOS
    })}>
        <div className="empty-favorite__container">
            <img
                className="empty-favorite__image"
                src={favorite}
                alt="Любимые"
            />
            <div className="empty-favorite__title">
                По каким-то причинам здесь пусто...
            </div>
        </div>
    </div>
);

export default EmptyFavorite;
